var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"field-label"},[_vm._v(_vm._s(_vm.question.label))]),_vm._v(" "),_c('div',{staticClass:"flex field-value"},[_vm._v("\n    "+_vm._s(_vm.hasTermData ?
      (_vm.termData.displayName || ("Semester " + (_vm.termData.semester) + ", " + (_vm.termData.year)))
      : '-')+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }